import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { withCrud, withNestedGrid, withApiResult, withMasked } from "~/hocs";
import { service, actions } from "./data";
import { preventBubbleUp } from "~/admin/utils";
import { messages } from "~/admin/agBytes/i18n-messages";
// Components
import AddEditPanel from "./add-edit/add-edit-container";
import { EquationLog } from "../common/equation-log/equation-log";
import { DialogBox, Button } from "~/core";
import { ImportExportHeader } from "~/admin/agBytes/components/import-export-header";
import EquationList from "../../equation-list/equation-list-container";
import NestedDataTable from "~/core/components/tables/nested-data-table/nested-data-table";
import SlidingPanel from "~/sliding-panel/sliding-panel";

export class EquationSets extends Component {
    static propTypes = {
        actions: PropTypes.object,
        addEditPanel: PropTypes.object,
        closeSidePanel: PropTypes.func,
        deleteSelected: PropTypes.func,
        intl: intlShape.isRequired,
        needs: PropTypes.func,
        setLastEditedRow: PropTypes.func,
        onSubmit: PropTypes.func,
        toggleActiveInactive: PropTypes.func,
        selectedRowTest: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.tableFooterOptions = [
            {
                label: "Delete Selected",
                action: this.props.deleteSelected,
            },
        ];
        this.state = {
            isModalOpen: false,
            selectedRow: null,
            showInactive: false,
        };
    }

    onRowSelection = (event, selectedRow) => {
        this.setState({
            selectedRow: selectedRow === this.state.selectedRow ? null : selectedRow,
        });
        if (this.props.setLastEditedRow) {
            this.props.setLastEditedRow();
        }
    };

    onToggleModalClick = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    toggleActiveInactive = () => {
        this.setState(
            {
                showInactive: !this.state.showInactive,
            },
            () => {
                this.props.toggleActiveInactive();
            }
        );
    };

    render() {
        const { formatMessage } = this.props.intl;
        const { showAddEditPanel } = this.props.addEditPanel;
        let slidingPanelProps = { ...this.props };
        if (showAddEditPanel) {
            slidingPanelProps = {
                ...slidingPanelProps,
                ...this.props.addEditPanel,
            };
        }
        return (
            <div className="content-table-container">
                <ImportExportHeader
                    {...this.props}
                    service={service}
                    onToggleModalClick={this.onToggleModalClick}
                    toggleActiveInactive={this.toggleActiveInactive}
                />
                <NestedDataTable
                    service={service}
                    messages={messages}
                    footerOptions={this.tableFooterOptions}
                    {...this.props}
                    onRowSelection={this.onRowSelection}
                    isCheckbox
                    isEditable
                    selectedRow={this.state.selectedRow}
                >
                    <EquationList
                        toggleActiveInactive={this.props.toggleActiveInactive}
                        showInactiveProp={this.state.showInactive}
                        onRowSelection={this.onRowSelection}
                        equationGroupType="Application"
                    />
                </NestedDataTable>
                {!showAddEditPanel ? null : (
                    <form onSubmit={(event) => preventBubbleUp(event)}>
                        <SlidingPanel
                            {...slidingPanelProps}
                            close={this.props.closeSidePanel}
                            component={AddEditPanel}
                            navigateTo={{
                                parentNameCode: "101",
                                childNameCode: "123",
                            }}
                        >
                            <Button type="save" forceSubmit onClick={() => this.props.onSubmit()} />
                            <Button type="cancel" onClick={() => this.props.closeSidePanel()} />
                        </SlidingPanel>
                    </form>
                )}
                <DialogBox
                    className="view-log-dialog-box"
                    isOpen={this.state.isModalOpen}
                    draggable
                    unrestricted
                    onClose={() => this.onToggleModalClick()}
                    title={formatMessage(messages.equationSetsLogHistory)}
                >
                    <EquationLog />
                </DialogBox>
            </div>
        );
    }
}

export default injectIntl(
    withMasked(
        withApiResult(withNestedGrid(withCrud(EquationSets, service, actions)), actions.importData)
    )
);
